module.exports = __webpack_public_path__ + "static/media/sprayQualityReportIcon.c91225e3.svg";